import React, { useContext } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, btnName, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import BlogPopup from "./BlogPopup";

const Blog = () => {
  const { setAllPopupState, allPopupState } = useContext(
    ByteCardBuilderContext
  );
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody className="support-ticket-font box-border-div">
            <Row>
              <div className="col-12">
                <CardBuilderHeaderSection name="Blog" />
              </div>
              <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.BLOG, setAllPopupState)
                }
                name={btnName.BLOG}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>

      <CommonPopup
        edit={false}
        open={allPopupState.blogPopup}
        close={() => OpenModalCommonFunc(Cases.BLOG, setAllPopupState, false)}
        modalName={modalsName.BLOG}
        modalCase={Cases.BLOG}
        content={<BlogPopup />}
      />
    </>
  );
};

export default Blog;
